module.exports = __webpack_public_path__ + "static/media/03_720.d39bbca6.jpeg";